import { ReservationInterface, ReservationStatus } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

/**
 * Studio-side client for the Phase 3a reservation endpoints. The
 * visitor-facing `POST /reservations/widget/{publicId}/commit` is widget-only
 * and not surfaced here; only the operator-facing list + status-flip routes.
 */
export class ReservationsAPI {
  static async list(orgId: number, status?: ReservationStatus) {
    const qs = status ? `?status=${encodeURIComponent(status)}` : "";
    return APIService.Server.get<ReservationInterface[]>(`/reservations/org/${orgId}${qs}`);
  }

  static async setStatus(orgId: number, reservationId: number, status: ReservationStatus) {
    return APIService.Server.put<ReservationInterface | null>(`/reservations/org/${orgId}/reservation/${reservationId}/status`, { status });
  }
}
